import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { Observable } from 'rxjs';

import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DropDownContent } from '../../../../Models/dropDownContent';
import { BusinessProcess } from '../../../../Models/businessProcess';
import { SecurableObjectAcessControlEntry } from '../../../../Models/SecurableObjectAcessControlEntry';
import {AdminService} from '../../../../services/admin.service';
import {BusinessProcessService} from '../../../../services/business-process.service';
import {AccessControlService} from '../../../../services/access-control.service';
import {SecurableObjectType} from '../../../../Models/enum/securableObjectType';
import {AccessControlComponent} from '../access-control.component';


@Component({
  selector: 'app-extraction-permission-list',
  templateUrl: './extraction-permission-list.component.html',
  styleUrls: ['../access-control.component.css']
})
export class ExtractionPermissionListComponent implements OnInit {

  @Input()
  extractionAccessControlEntries: SecurableObjectAcessControlEntry[];

  constructor(private accessControl: AccessControlComponent) { }

  ngOnInit() {
  }
}
